import { Link } from "react-router-dom";

export const Monogram = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="12" fill="#0A0A0A" stroke="#262626" strokeWidth="2" />
    <path d="M12 46V18h7l7 11 7-11h7v28h-7V30l-7 11-7-11v16z" fill="currentColor" />
    <text x="49" y="47" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="currentColor" textAnchor="middle">6</text>
  </svg>
);

const Logo = ({ light = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-3 group" aria-label="Moha66 — accueil">
    <Monogram className="w-9 h-9 text-white group-hover:text-gold transition-colors duration-300" />
    <span className={`font-display font-extrabold tracking-[0.18em] text-lg ${light ? "text-white" : "text-white"}`}>
      MOHA<span className="text-gold">66</span>
    </span>
  </Link>
);

export default Logo;
